import React from "react";

export default function Footer() {
  return (
    <div className="text-center">
      <p>
        <a href="https://github.com/senyp-test/weather_project">
          Open-source code
        </a>
      </p>
    </div>
  );
}
